export default function createAdminCardsArray(props) {
    const { isVerbAdmin, isAccountOwner, loggedInUserCompanyId, isContentReviewer, isContentAdmin, isContentAuthor } =
        props;

    const cardsArray = [];

    const manageCompanies = {
        link: '/admin/managecompanies',
        messageId: 'manage-companies',
        defaultMessage: 'Manage Companies',
        description: 'Go to Manage Companies',
        iconClasses: 'fal fa-building fa-10x admin-landing-page-icons'
    };

    const manageSubscriptions = {
        link: '/admin/managesubscriptions',
        messageId: 'manage-subscriptions',
        defaultMessage: 'Manage Subscriptions',
        description: 'Go to Manage Subscriptions',
        iconClasses: 'fal fa-folders fa-10x admin-landing-page-icons'
    };

    const manageCollections = {
        link: '/admin/managecollections',
        messageId: 'manage-collections',
        defaultMessage: 'Manage Collections',
        description: 'Go to Manage Collections',
        iconClasses: 'fal fa-books fa-10x admin-landing-page-icons'
    };

    const managePathways = {
        link: '/admin/managepathways',
        messageId: 'manage-pathways',
        defaultMessage: 'Manage Pathways',
        description: 'Go to Manage Pathways',
        iconClasses: 'fal fa-books fa-10x admin-landing-page-icons'
    };

    const manageLearningAssets = {
        link: '/admin/managelearningassets',
        messageId: 'manage-assets',
        defaultMessage: 'Manage Activities',
        description: 'Go to Manage Activities',
        iconClasses: 'fal fa-book-reader fa-10x admin-landing-page-icons'
    };

    const companyEmployees = {
        link: `/admin/editcompany/${loggedInUserCompanyId}/employees`,
        messageId: 'company-employees',
        defaultMessage: 'Company Employees',
        description: 'Go to Company Employees',
        iconClasses: 'fal fa-fw fa-user fa-10x admin-landing-page-icons'
    };

    const companyTeams = {
      link: `/admin/editcompany/${loggedInUserCompanyId}/teams`,
      messageId: 'company-teams',
      defaultMessage: 'Company Teams',
      description: 'Go to Company Teams',
      iconClasses: 'fal fa-fw fa-users fa-10x admin-landing-page-icons',
    };

    const companyInfo = {
        link: `/admin/editcompany/${loggedInUserCompanyId}/info`,
        messageId: 'company-info',
        defaultMessage: 'Company Info',
        description: 'Go to Company Info',
        iconClasses: 'fal fa-fw fa-info-circle fa-10x admin-landing-page-icons'
    };

    const companyBrand = {
        link: `/admin/editcompany/${loggedInUserCompanyId}/brand`,
        messageId: 'company-brand',
        defaultMessage: 'Company Brand',
        description: 'Go to Company Brand',
        iconClasses: 'fal fa-fw fa-heart fa-10x admin-landing-page-icons'
    };

    const companyHomePage = {
        link: `/admin/editcompany/${loggedInUserCompanyId}/layouts`,
        messageId: 'company-home-page',
        defaultMessage: 'Company Home Page',
        description: 'Go to Company Home Page',
        iconClasses: 'fal fa-fw fa-indent fa-10x admin-landing-page-icons'
    };

    // const companyNotifications = {
    //   link: `/admin/editcompany/${loggedInUserCompanyId}/notifications`,
    //   messageId: 'company-notifications',
    //   defaultMessage: 'Company Notifications',
    //   description: 'Go to Company Notifications',
    //   iconClasses: 'fal fa-fw fa-bell fa-10x admin-landing-page-icons',
    // };

    const reviewContent = {
        link: `/admin/managereviewcontent`,
        messageId: 'review-content',
        defaultMessage: 'Review Content',
        description: 'Go to Review Content',
        iconClasses: 'fal fa-cabinet-filing fa-10x admin-landing-page-icons'
    };

    const mediaLibrary = {
        link: `/admin/medialibrary`,
        messageId: 'MEDIA_LIBRARY',
        defaultMessage: 'Media Library',
        description: 'Go to Media Library',
        iconClasses: 'far fa-photo-video fa-10x admin-landing-page-icons'
    };

    const learningFrameworkCard = {
        link: `/admin/managecontentframework`,
        messageId: 'learning-framework',
        defaultMessage: 'Learning Framework',
        description: 'Go to Learning Framework',
        iconClasses: 'fal fa-cabinet-filing fa-10x admin-landing-page-icons'
    };

    const globalContent = {
        link: `/admin/manageglobalcontent`,
        messageId: 'global-content',
        defaultMessage: 'Global Content',
        description: 'Manage Global Content',
        iconClasses: 'fad fa-globe-stand fa-10x admin-landing-page-icons'
    };

    if (isContentReviewer) {
        cardsArray.push(reviewContent);
        return cardsArray;
    }
    if (isVerbAdmin) {
        cardsArray.push(manageCompanies);
        cardsArray.push(manageSubscriptions);
        cardsArray.push(manageLearningAssets);
        cardsArray.push(manageCollections);
        return cardsArray;
    }
    if (isAccountOwner) {
        // cardsArray.push(companyEmployees);

        cardsArray.push(companyTeams);
        // cardsArray.push(companyInfo);
        // cardsArray.push(companyBrand);
        cardsArray.push(companyHomePage);

        // cardsArray.push(companyNotifications);
        return cardsArray;
    }
    if (isContentAdmin) {
        cardsArray.push(manageLearningAssets);
        cardsArray.push(manageCollections);
        cardsArray.push(mediaLibrary);
        cardsArray.push(learningFrameworkCard);
        cardsArray.push(globalContent);
        return cardsArray;
    }
    if (isContentAuthor) {
        cardsArray.push(manageLearningAssets);
        cardsArray.push(managePathways);
        cardsArray.push(mediaLibrary);
        return cardsArray;
    }

    return cardsArray;
}
